export default __webpack_public_path__ + "static/media/vanguard.c85e2cb0.png";